import { makeStyles } from '@mui/styles';

export default makeStyles({
  fullHeight: {
    height: '100%',
  },
});
